import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import FlecheEnvoiClair from '../../assets/fleche_envoi_clair.png';
import {
  Container,
  ContentWrapper,
  ReturnButton,
  SubmitButton,
  LogoImage,
  ChatBubbleContainer,
  ChatText,
  LoadingOverlay,
  LogoBubbleWrapper
} from './styles';

import {
  GradeContainer,
  SliderContainer,
  SliderLabel,
  CustomSlider,
  SliderHeader,
  LabelIconWrapper,
  IconImage,
  GradeBadge,
  SliderLabelLeft,
  SliderLabelRight,
  SliderWrapper,
} from './styleGeneralMoyenne'; // Assurez-vous que le nom de fichier est correct

import compassImage from '../../assets/meo_write.png';
import moyenne_croissance_icon from '../../assets/moyenne_croissante_icon.png';

// Specialties icons
import artsIcon from '../../assets/arts_culture_icon.png';
import eppcsIcon from '../../assets/sport_icon.png';
import hggspIcon from '../../assets/hggsp_icon.jpeg';
import hlpIcon from '../../assets/hlp_icon.png';
import llcerIcon from '../../assets/llcer_icon.png';
import lcaIcon from '../../assets/lca_icon.png';
import mathIcon from '../../assets/math_icon.png';
import nsiIcon from '../../assets/informatique_icon.png';
import physChimIcon from '../../assets/physics_icon.png';
import svtIcon from '../../assets/svt_icon.png';
import siIcon from '../../assets/engineer_icon.png';
import sesIcon from '../../assets/ses_icon.png';
import bioEcoIcon from '../../assets/bioeco_icon.png';
import amcIcon from '../../assets/english_icon.png';

import ProgressBar from '../ProgressBar';
import useDeviceType from '../useDeviceType';
import apiCall from '../../utils/api';
import { useAuth } from '../../contexts/AuthContext';

const specialityOptions = [
  { value: 'arts', label: 'Arts', icon: artsIcon },
  { value: 'eppcs', label: 'Éducation physique, pratiques et cultures sportives', icon: eppcsIcon },
  { value: 'hggsp', label: 'Histoire-géographie, géopolitique et sciences politiques', icon: hggspIcon },
  { value: 'hlp', label: 'Humanités, littérature et philosophie', icon: hlpIcon },
  { value: 'llcer', label: 'Langues, littératures et cultures étrangères et régionales', icon: llcerIcon },
  { value: 'lca', label: "Littérature, langues et cultures de l'antiquité", icon: lcaIcon },
  { value: 'math', label: 'Mathématiques', icon: mathIcon },
  { value: 'nsi', label: 'Numérique et sciences informatiques', icon: nsiIcon },
  { value: 'physchim', label: 'Physique-Chimie', icon: physChimIcon },
  { value: 'svt', label: 'Sciences de la vie et de la Terre', icon: svtIcon },
  { value: 'si', label: "Sciences de l'ingénieur", icon: siIcon },
  { value: 'ses', label: 'Sciences économiques et sociales', icon: sesIcon },
  { value: 'bioeco', label: 'Biologie-Ecologie', icon: bioEcoIcon },
  { value: 'amc', label: 'Anglais Monde Contemporain', icon: amcIcon }
];

const GeneralMoyenne = () => {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const [grades, setGrades] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isTyping, setIsTyping] = useState(true);
  const [text, setText] = useState('');
  const [classeUser, setclasseUser] = useState('');
  const { isMobile } = useDeviceType();
  const [specialities, setSpecialities] = useState([]);
  const [typeBac, setTypeBac] = useState('');
  const url = window.location.href;
  const modifyProfile = url.includes('profile/modify');

  // Ref pour suivre l'état du drag
  const draggingInfo = useRef({
    isDragging: false,
    subject: null,
    sliderElement: null,
    min: 0,
    max: 20,
    step: 0.5,
  });

  const getMessage = (classeUser, typeBac) => {
    if (typeBac === 'technologique' || typeBac === 'professionnel') {
      return "Indique ta moyenne estimée au bac.";
    } else {
      switch (classeUser) {
        case 'terminale':
          return "Indique tes moyennes estimées au bac.";
        case 'premiere':
          return "Indique tes moyennes estimées au bac.";
        case 'seconde':
          return "Indique ta moyenne estimée au bac.";
        default:
          return "Indique tes moyennes au bac.";
      }
    }
  };

  useEffect(() => {
    let storedclasseUser = '';
    let storedTypeBac = '';
    let storedSpecialities = [];
    if (modifyProfile){
      const storedUserData = localStorage.getItem('user');
      if (storedUserData) {
        const user = JSON.parse(storedUserData);
        storedclasseUser = user.user_type;
        storedTypeBac = user.type_bac;
        storedSpecialities = user.specialites || [];
      }
    } else {
      storedclasseUser = localStorage.getItem('type_utilisateur');
      storedTypeBac = localStorage.getItem('type_bac');
      if (storedTypeBac === 'general') {
        const sp = localStorage.getItem('specialites');
        storedSpecialities = sp ? JSON.parse(sp) : [];
      }
    }
    setclasseUser(storedclasseUser);
    setTypeBac(storedTypeBac);
    setSpecialities(Array.isArray(storedSpecialities) ? storedSpecialities : []); // S'assurer que c'est un tableau
    const fullText = getMessage(storedclasseUser, storedTypeBac);
    let currentIndex = 0;
    const typingInterval = setInterval(() => {
      if (currentIndex <= fullText.length) {
        setText(fullText.slice(0, currentIndex));
        currentIndex++;
      } else {
        setIsTyping(false);
        clearInterval(typingInterval);
      }
    }, 15);
    return () => clearInterval(typingInterval);
  }, [modifyProfile]);

  const handleSliderChange = (subject, value) => {
    setGrades(prev => ({
      ...prev,
      [subject]: value
    }));
  };

  const calculateSliderValue = (clientX, sliderElement, min, max, step) => {
    if (!sliderElement) return min;
    const rect = sliderElement.getBoundingClientRect();
    let newValue;

    if (clientX <= rect.left) {
      newValue = min;
    } else if (clientX >= rect.right) {
      newValue = max;
    } else {
      const offsetX = clientX - rect.left;
      const width = rect.width;
      const percentage = offsetX / width;
      const rawValue = min + percentage * (max - min);
      newValue = Math.round(rawValue / step) * step;
    }
    return Math.max(min, Math.min(max, parseFloat(newValue.toFixed(1))));
  };

  const handleDragStart = (event, subject, min, max, step) => {
    // Si le clic est directement sur le slider input, laisser le onChange natif faire son travail
    if (event.target.tagName === 'INPUT' && event.target.type === 'range') {
      return;
    }
    // Empêcher la sélection de texte pendant le drag
    event.preventDefault();


    const sliderElement = event.currentTarget.querySelector('input[type="range"]');
    if (!sliderElement) return;

    draggingInfo.current = {
      isDragging: true,
      subject,
      sliderElement,
      min,
      max,
      step,
    };

    const clientX = event.type === 'touchstart' ? event.touches[0].clientX : event.clientX;
    const newValue = calculateSliderValue(clientX, sliderElement, min, max, step);
    handleSliderChange(subject, newValue);

    document.addEventListener('mousemove', handleDragMove);
    document.addEventListener('touchmove', handleDragMove, { passive: false }); // passive: false pour preventDefault
    document.addEventListener('mouseup', handleDragEnd);
    document.addEventListener('touchend', handleDragEnd);
  };

  const handleDragMove = (event) => {
    if (!draggingInfo.current.isDragging) return;

    // Empêcher le défilement de la page sur mobile pendant le drag
    if (event.type === 'touchmove') {
        event.preventDefault();
    }

    const clientX = event.type === 'touchmove' ? event.touches[0].clientX : event.clientX;
    const { subject, sliderElement, min, max, step } = draggingInfo.current;
    const newValue = calculateSliderValue(clientX, sliderElement, min, max, step);
    handleSliderChange(subject, newValue);
  };

  const handleDragEnd = () => {
    if (!draggingInfo.current.isDragging) return;
    draggingInfo.current.isDragging = false;
    document.removeEventListener('mousemove', handleDragMove);
    document.removeEventListener('touchmove', handleDragMove);
    document.removeEventListener('mouseup', handleDragEnd);
    document.removeEventListener('touchend', handleDragEnd);
  };

  // Nettoyage des écouteurs globaux si le composant est démonté pendant un drag
  useEffect(() => {
    return () => {
      if (draggingInfo.current.isDragging) {
        document.removeEventListener('mousemove', handleDragMove);
        document.removeEventListener('touchmove', handleDragMove);
        document.removeEventListener('mouseup', handleDragEnd);
        document.removeEventListener('touchend', handleDragEnd);
      }
    };
  }, []);


  const isSubmitEnabled = () => {
    if (classeUser === 'seconde' || typeBac === 'professionnel' || typeBac === 'technologique') {
      return grades.general !== undefined && grades.general >= 0;
    } else if (typeBac === 'general') {
        if (classeUser === 'premiere' || classeUser === 'terminale') {
            return specialities.length > 0 &&
                   grades.general !== undefined && grades.general >= 0 &&
                   specialities.every(subject => grades[subject] !== undefined && grades[subject] >= 0);
        } else {
            return grades.general !== undefined && grades.general >= 0;
        }
    }
    return false;
  };


  const handleSubmit = async () => {
    if (!isSubmitEnabled() || isTyping) return;
    setIsLoading(true);
    try {
      if(modifyProfile){
        await apiCall(`${process.env.REACT_APP_BACKEND_URL}/auth/user/update/`, 'PATCH', {
          grades: grades
        });
        var userData = JSON.parse(localStorage.getItem('user'));
        userData.grades = grades;
        localStorage.setItem('user', JSON.stringify(userData));
        localStorage.setItem('need_update_ranking', 'true');
        localStorage.setItem('need_update_ranking_formation', 'true');
        await checkAuth();
        navigate('/profile');
      } else {
        localStorage.setItem('grades', JSON.stringify(grades));
        navigate('/domaines-favoris');
      }
    } catch (error) {
      console.error('Error saving grades:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBack = () => {
    if (modifyProfile) {
      navigate('/profile');
    } else {
      navigate("/type-bac");
    }
  };

  useEffect(() => {
    const sliders = document.querySelectorAll('input[type="range"]');
    sliders.forEach(slider => {
      const updateProgress = () => {
        const value = parseFloat(slider.value);
        const min = parseFloat(slider.min);
        const max = parseFloat(slider.max);
        const progress = ((value - min) / (max - min)) * 100;
        slider.style.setProperty('--progress', `${progress}%`);
      };
      updateProgress();
      slider.addEventListener('input', updateProgress);
      return () => {
        slider.removeEventListener('input', updateProgress);
      };
    });
  }, [grades, specialities, typeBac, classeUser]);

  const renderSliders = () => {
    const slidersToRender = [];
    const minGrade = 0;
    const maxGrade = 20;
    const stepGrade = 0.5;

    // Toujours afficher le slider de moyenne générale
    slidersToRender.push(
      <SliderContainer
        key="general"
        onMouseDown={(e) => handleDragStart(e, 'general', minGrade, maxGrade, stepGrade)}
        onTouchStart={(e) => handleDragStart(e, 'general', minGrade, maxGrade, stepGrade)}
      >
        <SliderHeader>
          <LabelIconWrapper>
            <IconImage src={moyenne_croissance_icon} alt="Moyenne Croissante" />
            <SliderLabel>Moyenne générale</SliderLabel>
          </LabelIconWrapper>
          <GradeBadge>{grades.general !== undefined ? grades.general.toFixed(1) : '0.0'}/20</GradeBadge>
        </SliderHeader>
        <SliderWrapper>
          <SliderLabelLeft>{minGrade}</SliderLabelLeft>
          <CustomSlider
            type="range"
            min={minGrade}
            max={maxGrade}
            step={stepGrade}
            value={grades.general || minGrade}
            onChange={(e) => handleSliderChange('general', parseFloat(e.target.value))}
            // Pour éviter que le drag du parent n'interfère avec le drag natif du thumb
            onMouseDown={(e) => e.stopPropagation()}
            onTouchStart={(e) => e.stopPropagation()}
          />
          <SliderLabelRight>{maxGrade}</SliderLabelRight>
        </SliderWrapper>
      </SliderContainer>
    );

    // Sliders pour les spécialités
    if (typeBac === 'general' && (classeUser === 'premiere' || classeUser === 'terminale')) {
      specialities.forEach((subjectValue) => {
        const option = specialityOptions.find(opt => opt.value === subjectValue);
        if (option) {
          slidersToRender.push(
            <SliderContainer
              key={option.value}
              onMouseDown={(e) => handleDragStart(e, option.value, minGrade, maxGrade, stepGrade)}
              onTouchStart={(e) => handleDragStart(e, option.value, minGrade, maxGrade, stepGrade)}
            >
              <SliderHeader>
                <LabelIconWrapper>
                  <IconImage src={option.icon} alt={option.label} />
                  <SliderLabel>{option.label}</SliderLabel>
                </LabelIconWrapper>
                <GradeBadge>{grades[option.value] !== undefined ? grades[option.value].toFixed(1) : '0.0'}/20</GradeBadge>
              </SliderHeader>
              <SliderWrapper>
                <SliderLabelLeft>{minGrade}</SliderLabelLeft>
                <CustomSlider
                  type="range"
                  min={minGrade}
                  max={maxGrade}
                  step={stepGrade}
                  value={grades[option.value] || minGrade}
                  onChange={(e) => handleSliderChange(option.value, parseFloat(e.target.value))}
                  onMouseDown={(e) => e.stopPropagation()}
                  onTouchStart={(e) => e.stopPropagation()}
                />
                <SliderLabelRight>{maxGrade}</SliderLabelRight>
              </SliderWrapper>
            </SliderContainer>
          );
        }
      });
    }
    return slidersToRender;
  };

  const [submitActive, setSubmitActive] = useState(false);

  const handleSubmitPressStart = () => {
    if (!isSubmitEnabled() || isTyping) return;
    setSubmitActive(true);
  };

  const handleSubmitPressEnd = () => {
    if (!isSubmitEnabled() || isTyping) return;
    setSubmitActive(false);
    setTimeout(() => {
      handleSubmit();
    }, 100);
  };

  return (
    <Container>
      {isLoading && <LoadingOverlay isLoading={isLoading} />}
      <ReturnButton onClick={handleBack}>
        <img src={FlecheEnvoiClair} alt="Back" style={{ width: '24px', height: '24px' }} />
      </ReturnButton>
      <ContentWrapper>
      {!modifyProfile && <ProgressBar startPercent={40} endPercent={50} />}
        <LogoBubbleWrapper>
          <LogoImage src={compassImage} alt="Compass Logo" />
          <ChatBubbleContainer isMobile={isMobile}>
            <ChatText isVisible={text.length > 0}>
              <span>{text}</span>
            </ChatText>
          </ChatBubbleContainer>
        </LogoBubbleWrapper>
        <GradeContainer style={{
          opacity: isTyping ? 0 : 1,
          transition: 'opacity 0.3s ease',
          pointerEvents: isTyping ? 'none' : 'auto'
        }}>
          {renderSliders()}
        </GradeContainer>
        <SubmitButton
          onMouseDown={handleSubmitPressStart}
          onMouseUp={handleSubmitPressEnd}
          onMouseLeave={() => {if (submitActive) setSubmitActive(false);}}
          onTouchStart={handleSubmitPressStart}
          onTouchEnd={handleSubmitPressEnd}
          active={submitActive}
          disabled={!isSubmitEnabled() || isTyping}
          type="button"
          style={{
            opacity: (!isSubmitEnabled() || isTyping) ? 0.5 : 1,
            cursor: (!isSubmitEnabled() || isTyping) ? 'not-allowed' : 'pointer'
          }}
        >
          {isLoading ? 'Chargement...' : modifyProfile ? 'Valider' : 'Continuer'}
        </SubmitButton>
      </ContentWrapper>
    </Container>
  );
};

export default GeneralMoyenne;